
import EventType from '@/model/enums/EventType';
import { Component, ModelSync, Vue } from 'vue-property-decorator';
import EventIcon from '@/components/event/EventIcon.vue';

@Component({
    components: {
        EventIcon,
    },
})
export default class EventTypePicker extends Vue {
    @ModelSync('type', 'change', { type: String })
    typeValue!: EventType;

    get eventTypes(): EventType[] {
        return Object.keys(EventType) as EventType[];
    }
}
